import { Auth0Provider } from '@auth0/auth0-react';
import { App, ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';

import AppMain from './App';
import reportWebVitals from './reportWebVitals';
import { Theme } from './theme';

const onRedirectCallback = (appState) => {
  window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  // eslint-disable-next-line react/jsx-filename-extension
  <Auth0Provider
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: process.env.REACT_APP_AUDIENCE
    }}
    cacheLocation="localstorage"
    clientId={process.env.REACT_APP_CLIENTID}
    domain={process.env.REACT_APP_DOMAIN}
    onRedirectCallback={onRedirectCallback}>
    <ConfigProvider theme={Theme}>
      <App>
        <BrowserRouter>
          <AppMain />
        </BrowserRouter>
      </App>
    </ConfigProvider>
  </Auth0Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
